import LogosAndParagraphLogosConfig from "./logos-and-paragraph-logos-config";
import LogosAndParagraphLogosAdvancedConfig from "./logos-and-paragraph-logos-advanced-config";
import dynamic from "next/dynamic";
const LogosAndParagraphLogosComponent = dynamic(()=>import("./logos-and-paragraph-logos-component"));
export default {
    LogosAndParagraphLogosComponent,
    LogosAndParagraphLogosConfig,
    LogosAndParagraphLogosAdvancedConfig
};
